import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-24 bg-[#1C1816] text-[#F5F2EB]"
    >
      <div
        className="absolute inset-0 opacity-20 pointer-events-none"
        style={{
          backgroundImage:
            "url('https://static.prod-images.emergentagent.com/jobs/2d534211-f673-4bdf-b323-dbc700b856c8/images/38d9b7f897e91908f2b611e80e5c18cb53804d6a44d9c00610db8fad89a474fb.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          mixBlendMode: "overlay",
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-20 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <img
            src="/logo-leather.png"
            alt="The Woodworkers Shed"
            className="h-16 md:h-20 w-auto mb-6"
            draggable={false}
          />
          <div className="font-serif text-3xl mb-4">The Woodworkers Shed</div>
          <p className="text-[#F5F2EB]/70 max-w-md leading-relaxed">
            Heirloom-quality timber pieces, hand-built in New Zealand.
            One workshop. One pair of hands. Made to last a lifetime.
          </p>
          <div className="flex items-center gap-4 mt-8">
            <a
              href="https://www.instagram.com/the.woodworkersshed/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram — the.woodworkersshed"
              data-testid="footer-instagram"
              className="p-2 border border-[#F5F2EB]/20 hover:border-[#F5F2EB]/60 transition-colors"
            >
              <Instagram size={16} />
            </a>
            <a
              href="https://www.facebook.com/TheWoodWorkersShed"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook — The Wood Workers Shed"
              data-testid="footer-facebook"
              className="p-2 border border-[#F5F2EB]/20 hover:border-[#F5F2EB]/60 transition-colors"
            >
              <Facebook size={16} />
            </a>
            <a
              href="mailto:thewoodworkersshed@outlook.co.nz"
              aria-label="Email"
              data-testid="footer-email"
              className="p-2 border border-[#F5F2EB]/20 hover:border-[#F5F2EB]/60 transition-colors"
            >
              <Mail size={16} />
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="eyebrow !text-[#A89F91] mb-4">Explore</div>
          <ul className="space-y-3">
            <li><Link to="/shop" className="link-underline text-[#F5F2EB]/85">Shop</Link></li>
            <li><Link to="/story" className="link-underline text-[#F5F2EB]/85">Our Story</Link></li>
            <li><Link to="/commissions" className="link-underline text-[#F5F2EB]/85">Commissions</Link></li>
            <li><Link to="/care" className="link-underline text-[#F5F2EB]/85">Care</Link></li>
            <li><Link to="/contact" className="link-underline text-[#F5F2EB]/85">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="eyebrow !text-[#A89F91] mb-4">Workshop</div>
          <p className="text-[#F5F2EB]/70 leading-relaxed">
            By appointment.<br />
            Whangamata, Aotearoa.<br />
            thewoodworkersshed@outlook.co.nz
          </p>
        </div>
      </div>

      <div className="relative border-t border-[#F5F2EB]/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#F5F2EB]/50">
          <div>© {new Date().getFullYear()} The Woodworkers Shed. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" data-testid="footer-privacy" className="link-underline hover:text-[#F5F2EB]/80">
              Privacy policy
            </Link>
            <div className="tracking-[0.2em] uppercase">Made by hand · Aotearoa</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
